import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - scrolls to top on every route change
 * Place this inside BrowserRouter to ensure pages open at the top
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Use useLayoutEffect for synchronous scroll before paint
  useLayoutEffect(() => {
    // Only scroll to top if there's no hash (anchor link)
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  // Also scroll on initial mount and add a backup with useEffect
  useEffect(() => {
    if (!hash) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }, 0);
      return () => clearTimeout(timer);
    }
  }, [pathname, hash]);

  return null;
}
